/* eslint-disable no-empty,no-nested-ternary,no-underscore-dangle */

xplenty.service('variables', [
  'Variable',
  '$rootScope',
  'notify',

  function (Variable, $rootScope, notify) {
    return {
      systems: [],
      getSystems(callback) {
        const _this = this;
        if (_this.systems.length) {
          callback(_this.systems);
        } else if ($rootScope._systemVariables) {
          _this.systems = $rootScope._systemVariables;
          callback($rootScope._systemVariables);
        } else {
          Variable.get().subscribe(
            function (items) {
              _this.systems = items;
              callback(_this.systems);
            },
            function () {
              notify.error(null, 'Failed to load system variables');
            },
          );
        }
      },
      separateVariables(vars, defaultVars, usePackageDefault, callback) {
        console.log('vars', vars);
        console.log('defaultVars', defaultVars);

        const _this = this;
        this.getSystems(function (systems) {
          const result = {
            systemVariables: [],
            userVariables: [],
            predefinedVariables: _this.predefined,
          };
          _.forIn(vars, function (value, key) {
            if (_.has(systems, key)) {
              return;
            }
            result.userVariables.push({
              key,
              value,
              default: usePackageDefault ? (_.has(defaultVars, key) ? defaultVars[key] : value) : value,
            });
          });

          _.forIn(systems, function (value, key) {
            result.systemVariables.push({
              key,
              value: _.has(vars, key) ? vars[key] : value,
              default: value, // usePackageDefault ? (_.has(vars, key) ? vars[key] : value) : value,
              type: 'string',
            });
          });

          callback(result);
        });
      },
      combineVariables(users, systems, callback) {
        this.getSystems(function (defaults) {
          const result = {};
          users.forEach(function (v) {
            result[v.key] = v.value;
          });
          systems.forEach(function (v) {
            if (v.value !== defaults[v.key]) {
              result[v.key] = v.value;
            }
          });
          callback(result);
        });
      },

      diffVariables(var1, var2 = {}) {
        const diff = {};
        if (!var1) return {};
        _.forIn(var1, function (value, key) {
          if (_.has(var2, key) && var2[key] === value) {
          } else {
            diff[key] = value;
          }
        });
        return diff;
      },

      predefined: [
        {
          key: '_ACCOUNT_ID',
          help: 'The internal id of the account under which the package and job were created.',
        },
        {
          key: '_ACCOUNT_ID_S3_ESCAPED',
          help: 'The S3 escaped internal id of the account under which the package and job were created.﻿',
        },
        {
          key: '_ACCOUNT_NAME',
          help: 'The name of the account under which the package and job were created.',
        },
        {
          key: '_ACCOUNT_NAME_S3_ESCAPED',
          help: 'The S3 escaped name of the account under which the package and job were created.',
        },
        {
          key: '_CLUSTER_ID',
          help: 'The ID of the cluster on which the job is running.',
        },
        {
          key: '_CLUSTER_ID_S3_ESCAPED',
          help: 'The S3 escaped ID of the cluster on which the job is running.',
        },
        {
          key: '_CLUSTER_NODES_COUNT',
          help: 'The number of nodes in the cluster that executes the job.',
        },
        {
          key: '_JOB_ID',
          help: 'Xplenty Job Identifier.',
        },
        {
          key: '_JOB_ID_S3_ESCAPED',
          help: 'S3 escaped Xplenty Job Identifier.',
        },
        {
          key: '_JOB_SUBMISSION_TIMESTAMP',
          help: 'ISO-8601 date-time value of the time the job was submitted in UTC. For example: 2013-04-22T14:18:17Z',
        },
        {
          key: '_JOB_SUBMISSION_TIMESTAMP_S3_ESCAPED',
          help:
            'S3 escaped date-time value of the time the job was submitted in UTC. For example: 2013-01-09T14-52-21Z',
        },
        {
          key: '_JOB_SUBMITTER_EMAIL',
          help: 'The email address of the user who submitted the job. For example: helpdesk@xplenty.com',
        },
        {
          key: '_JOB_SUBMITTER_EMAIL_S3_ESCAPED',
          help: 'The S3 escaped email address of the user who submitted the job. For example: helpdesk-xplenty-com',
        },
        {
          key: '_PACKAGE_LAST_SUCCESSFUL_JOB_SUBMISSION_TIMESTAMP',
          help: '',
        },
        {
          key: '_PACKAGE_OWNER_EMAIL',
          help: 'The email address of the user who owns the package.',
        },
        {
          key: '_PACKAGE_OWNER_EMAIL_S3_ESCAPED',
          help: 'The S3 escaped email address of the user who owns the package.',
        },
      ],
    };
  },
]);
